// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import AnimValueProgress from "../../engines/components/animation/AnimValueProgress";
import BasePopUpLayer from "../../engines/components/BasePopUpLayer";
import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import PromiseUtil from "../../engines/libs/PromiseUtil";
import utilsModel from "../../engines/libs/utilsModel";
import utilsView from "../../engines/libs/utilsView";
import CsvDataManage from "../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import { GeneralKind } from "../../modes/define/GeneralKind";
import { UIKind } from "../../modes/define/UIKind";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../modes/normalMode/BundleResourceConfig";
import { backpackOpenType } from "../../modes/normalMode/config/backpackConst";
import { backPackEventMap } from "../../modes/normalMode/config/BackpackEventConfig";
import { NormalBackpackI } from "../../modes/normalMode/manager/DefineInterface";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import BackpackPrefab from "../../modes/normalMode/prefab/backpack/BackpackPrefab";

const {ccclass, property} = cc._decorator;


const c_max_good = 1000;
const c_every_day_sub = 30;

/** 重置点击次数时间 */
const c_reset_touch_time = 2;

enum SpecialType {
    /** 扣除10亿 */
    TYPE1 = 1,
    /** 打开背包 赠送绣春刀 */
    TYPE2,
}

class SpecialInfo {
    talk?: string;
    select?: SpecialSelectInfo[];
}

class SpecialSelectInfo {
    btn: string;
    info?: SpecialInfo;
    infoErr?: SpecialInfo;
    btnType?: SpecialType;
}

const cSpecialList: SpecialInfo = {
    talk: '你到底想干嘛呀'
    , select: [
        {
            btn: '约  会'
            , info: {
                talk: '店里的伙计都不在，恕我今日不能陪公子外出'
                , select: [
                    {
                        btn: '离  开'
                    }
                ]
            }
        }
        , {
            btn: '娶  你'
            , info: {
                talk: '小女子相貌一般，公子为何要娶我'
                , select: [
                    {
                        btn: '因为喜欢，诚心娶你'
                        , info: {
                            talk: '还请公子表示一下你的诚意'
                            , select: [
                                {
                                    btn: '出10个亿'
                                    , info: {
                                        talk: '小女子家底可能比公子还会多一点'
                                    }
                                    , btnType: SpecialType.TYPE1
                                },
                                {
                                    btn: '赠送信物'
                                    , info: {
                                        talk: '这《商贾秘术》是先祖留下的不传秘术，先交予公子保管'
                                    }
                                    , infoErr: {
                                        talk: '区区俗物，小女子还是能淘到，还请公子拿出点诚意'
                                    }
                                    , btnType: SpecialType.TYPE2
                                },
                                {
                                    btn: '我妈会游泳'
                                    , info: {
                                        talk: '我也会游泳'
                                    }
                                },
                                {
                                    btn: '房本写你名'
                                    , info: {
                                        talk: '公子说笑了，我们家商铺有3万多间'
                                    }
                                },
                            ]
                        }
                    }
                ]
            }
        }
    ]
}
@ccclass
export default class PawnLayer extends BasePopUpLayer {

    @property(cc.Node)
    nodeSpecialItem: cc.Node = null;
    @property(cc.Node)
    nodeSpecialList: cc.Node = null;

    @property(cc.Node)
    nodeRansom: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGood: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGoodName: cc.Label = null;
	@property({ type: cc.Label, displayName:'' })
	labelNum: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGoodAdd: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	btnAdAddGood: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprGoods: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeMain: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSell: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGood: cc.Node = null;

	@property({ type: AnimValueProgress, displayName:'' })
	progressGood: AnimValueProgress = null;

	@property({ type: cc.RichText, displayName:'' })
	labelTalk: cc.RichText = null;

	@property({ type: cc.Node, displayName:'' })
	sprTalkBg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeRoleTalk: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    private csvInfo: any = null;
    private talkSpaceY = 0;
    private price = 0;
    private goodsData: NormalBackpackI = null;

    private selectCount: number = 0;

    /** 点击次数 */
    private touchCount = 0;

    private bOpenRansom = false;

    private bOpenSpecial1 = false;

    private recordTalk1 = '';

    private specialSelectList: SpecialSelectInfo[] = [];

    start () {

        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.PAWN, this.node);

        this.nodeSpecialItem.active = false;
        this.initLayer();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.PAWN);
    }

    initLayer() {

        
        this.nodeRansom.active = false;
        this.getGood();
        this.labelGoodAdd.node.active = false;
        this.showPawnState(false);
        this.talkSpaceY = this.sprTalkBg.height - this.labelTalk.node.height;
        this.refreshGoodState();

        this.showTalk(this.csvInfo.init_hint);

        let gameData = NormalGameManager._instance.getGameData();

        this.refreshSpeical1State();
        if (!gameData.bFirstEnterPawn) {
            gameData.bFirstEnterPawn = true;
            NormalGameManager._instance.writeGameData();
            NormalGameManager._instance.addOneWeChatTriggerLinkUnShift(GeneralKind.TriggerChatId.FIRST_ENTER_PAWN);
        }
    }

    refreshSpeical1State() {
        let gameData = NormalGameManager._instance.getGameData();

        this.bOpenSpecial1 = gameData.bGetPawnSpecialGoods1;
    }

    getGood() {
        let gameData = NormalGameManager._instance.getGameData();
        let curDay = NormalGameManager._instance.getCurrentDay();
        if (curDay != gameData.lastRecordSubGood) {
            let sub = (curDay-gameData.lastRecordSubGood);
            gameData.lastRecordSubGood = curDay;
            if (sub > 0) {
                sub *= c_every_day_sub;
                gameData.curGoodValue = Math.max(0, gameData.curGoodValue - sub);
            }
            NormalGameManager._instance.writeGameData();
        }
    }

    refreshStageInfo() {
        let id = this.getCurGoodStageId();
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.PAWN, id);
        if (!this.csvInfo) {
            console.error(`未找到典当数据 id `,id);
            return;
        }
    }

    getCurGoodStageId() {
        let gameData = NormalGameManager._instance.getGameData();
        let curGoodValue = gameData.curGoodValue;
        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.PAWN);
        let title = csvInfo.title;
        for (let i in csvInfo) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfo[i];
            let good_min = info[title.good_min];
            let good_max = info[title.good_max];
            if (utilsModel.isValidNumberValue(good_min)) {
                let gmin = Number(good_min);
                if (curGoodValue < gmin) {
                    continue;
                }
            }
            if (utilsModel.isValidNumberValue(good_max)) {
                let gmax = Number(good_max);
                if (curGoodValue > gmax) {
                    continue;
                }
            } else {
                return i;
            }
            return i;
        }
        return null;
    }

    showPawnState(enable: boolean) {
        this.nodeSell.active = enable;
        this.nodeMain.active = !enable;

        if (enable) {
            this.refreshAdUI();
        }
    }

    refreshAdUI() {
        let curDay = NormalGameManager._instance.getCurrentDay();
        let gameData = NormalGameManager._instance.getGameData();
        let bShow = curDay != gameData.lastAdGoodData;
        this.btnAdAddGood.active = bShow;
    }

    refreshGoodState(bPalyAni: boolean = false) {
        let preid = this.csvInfo && Number(this.csvInfo.id) || 0;
        this.refreshStageInfo();
        let curid = this.csvInfo && Number(this.csvInfo.id) || 0;
        
        let gameData = NormalGameManager._instance.getGameData();
        let curGoodValue = gameData.curGoodValue;

        let good_max = this.csvInfo.good_max;
        if (!utilsModel.isValidNumberValue(good_max)) {
            good_max = c_max_good + '';
        }
        let maxGood = Math.min(c_max_good, Number(good_max));
        if (curid > preid) {
            this.progressGood.setValue(0, true, false);
        }
        this.refreshProgress(curGoodValue, maxGood, bPalyAni);
    }

    showTalk(str: string) {
        this.labelTalk.string = str;
        // utilsView.refreshLabelUI(this.labelTalk);
        this.sprTalkBg.height = this.labelTalk.node.height + this.talkSpaceY;
        this.sprTalkBg.children.forEach((v)=> {
            v.getComponent(cc.Widget).updateAlignment();
        });
    }

    refreshProgress(
        curV: number
        , totalV: number
        , bPalyAni: boolean = false
    ) {
        this.labelGoodName.string = this.csvInfo.good_name;
        this.labelGood.string = curV + '/' + totalV;
        let progressValue = Math.min(curV / totalV, 1);
        this.progressGood.setValue(progressValue, true, bPalyAni);
    }

    /**
     * 提升好感
     * @param goodValue 
     */
    promoteGoodValue(goodValue: number) {
        let gameData = NormalGameManager._instance.getGameData();
        gameData.curGoodValue += goodValue;
        NormalGameManager._instance.writeGameData();
        this.refreshGoodState(true);

        let nodeItem = cc.instantiate(this.labelGoodAdd.node);
        nodeItem.active = true;
        nodeItem.parent = this.labelGoodAdd.node.parent;
        let label = nodeItem.getComponent(cc.Label);
        label.string = '好感+' + goodValue;

        let tm = 0.35;
        cc.tween(nodeItem)
        .delay(0.7)
        .parallel(
            cc.tween(nodeItem).to(tm, {opacity: 50})
            , cc.tween(nodeItem).to(tm, {y: 20})
            // , cc.tween(nodeItem).to(tm, {scale: 0.9})
        )
        .removeSelf()
        .start();
    }

    async showGoods(goodsId: number) {
        let goodsConfig = backPackEventMap()[goodsId];
        let spPath = goodsConfig.spPath;
        let sprGoods = this.sprGoods;
        let gwidth = sprGoods.node.width * sprGoods.node.scaleX;
        let gheight = sprGoods.node.height * sprGoods.node.scaleY;

        this.labelNum.string = goodsConfig.name + '×' + this.selectCount;
        sprGoods.node.active = false;
        let iconPath = "backpackAssets/objSp/" + spPath;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    sprGoods.node.active = true;
                    sprGoods.spriteFrame = imgs;

                    let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                    sprGoods.node.scale = scale;    
                }
            }
        );
    }

    refreshGoodsPrice(bAd: boolean = false) {
        let scalePrice = Number(this.csvInfo.price_scale);
        let price = this.goodsData.sellPrice * this.selectCount * (1+scalePrice);
        let strHint: string = bAd ? this.csvInfo.ad_bid_hint : this.csvInfo.bid_hint;

        this.price = Math.floor(price * (bAd ? 2 : 1));
        let rex = new RegExp(GeneralKind.ValueChangeType.GOLD, 'g');
        strHint = strHint.replace(rex, data_control.getNumberFormat(this.price) + '<img src="gold"/> ');
        this.showTalk(strHint);
    }

    async selectGood() {
        return new Promise<{item:NormalBackpackI, count: number}>(async aresolve=>{
            let url = "backpack/backpackPrefab";
            let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
            if(prefab){
                let backpack = cc.instantiate(prefab);
                backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.selectCount,null,(item:NormalBackpackI, count?: number)=>{
                    aresolve({
                        item: item
                        , count:count
                    });
                }
                , (item:NormalBackpackI)=>{
                    aresolve(null);
                }
                );
                O1HD.Canvas().addChild(backpack);
            } else {
                aresolve(null);
            } 
        });
    }
    
    async onClickSendGoods() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let item = await this.selectGood();
        if (!item) {
            console.error(`数据错误`);
            return;
        }
        NormalGameManager._instance.onOutGoods(item.item.id, item.count);
        if (utilsModel.isValidNumberValue(item.item.goodValue)) {
            this.promoteGoodValue(item.item.goodValue * item.count);
        }
        this.showTalk('谢谢你的礼物，我回头仔细看看');
    }

    async onClickPawn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let item = await this.selectGood();
        if (!item) {
            console.error(`数据错误`);
            return;
        }
        this.goodsData = item.item;
        this.selectCount = item.count;
        this.showPawnState(true);
        this.showGoods(item.item.id);

        this.refreshGoodsPrice();
    }

    onClickSell() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.showPawnState(false);
        NormalGameManager._instance.onOutGoods(this.goodsData.id, this.selectCount);
        O1HD.getServices().userSrv.setCoins(this.price, true, this.sprGoods.node);
        this.showTalk('还有什么事吗？');
    }

    onClickNoSell() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.showPawnState(false);

        this.showTalk('还有什么事吗？');
    }

    adSuccessAddGood() {
        let curDay = NormalGameManager._instance.getCurrentDay();
        let gameData = NormalGameManager._instance.getGameData();
        gameData.lastAdGoodData = curDay;
        NormalGameManager._instance.writeGameData();

        this.promoteGoodValue(100);
        this.refreshGoodsPrice(true);
        this.refreshAdUI();
    }

    onClickAdAddGood() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.adSuccessAddGood();
        },()=>{

        },null,"观看广告提升好感度")
    }

    resetTouchCount() {
        this.touchCount = 0;
    }

    openRansomGoodsLayer() {
        this.showTalk('这些东西需要重金赎回哟~');
        this.bOpenRansom = true;
        this.nodeRansom.active = true;
        this.nodeRansom.opacity = 0;
        cc.tween(this.nodeRansom)
        .to(0.25, {opacity: 255})
        .start();
    }

    onClickRansom() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.PawnRansomGoodsLayer);
    }

    showSpecialTalk1() {
        if (this.bOpenSpecial1) {
            return;
        }
        this.touchCount++;
        if (this.touchCount >= 5) {
            this.bOpenSpecial1 = true;
            this.resetTouchCount();

            if (this.nodeSell.active) {
                this.nodeSell.scale = 0;
            }

            if (this.nodeMain.active) {
                this.nodeMain.scale = 0;
            }
            this.recordTalk1 = this.labelTalk.string;
            this.startSpeicalDialogue(cSpecialList);
        } else {
            this.scheduleOnce(this.resetTouchCount, c_reset_touch_time);
        }
    }

    async startSpeicalDialogue(info: SpecialInfo) {

        if (info.talk) {
            this.showTalk(info.talk);
        }
        this.specialSelectList = null;
        if (info.select) {
            this.specialSelectList = info.select;
            this.nodeSpecialList.removeAllChildren();

            for (let i = 0; i < info.select.length; i++) {
                let o = info.select[i];
                let nodeItem = cc.instantiate(this.nodeSpecialItem);
                nodeItem.active = true;

                let label = nodeItem.getChildByName('Label').getComponent(cc.Label);
                label.string = o.btn;

                if (info.select.length == 1) {
                    nodeItem.parent = this.nodeSpecialItem.parent;
    
                    let oriW = this.nodeSpecialItem.width;
                    utilsView.refreshLabelUI(label);
                    let cW = Math.max(oriW, label.node.width + 60);
                    nodeItem.width = cW;
                } else {
                    this.nodeSpecialList.addChild(nodeItem);
                }

                let btnCom = nodeItem.getComponent(cc.Button);
                btnCom.clickEvents[0].customEventData = '' + i;
            }
        } else {
            await PromiseUtil.sleep(2);
            if (!this.node || !cc.isValid(this.node)) {
                return;
            }
            this.restoreRecord1();
        }
    }

    async onClickSpecilItem(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        if (data == 'finish') {
            event.getCurrentTarget().destroy();
            NormalGameManager._instance.setGameData({bGetPawnSpecialGoods1: true});
            NormalGameManager._instance.pawnBossMarryDataDispose();
            await this.sendSpecialGoods();
            this.destroyNode();
            return;
        }

        let idx = Number(data);
        let bFinish = false;
        let info = this.specialSelectList[idx];
        if (info.info) {
            let einfo = info.info;
            if (info.btnType) {
                switch(info.btnType) {
                    case SpecialType.TYPE1: {
                        let gold = 1000000000;
                        let coin = O1HD.getServices().userSrv.getCoins();
                        if (coin < gold) {
                            O1HD.getModules().uiControlModule.showMessageBox('金额不足');
                            return;
                        }
                        O1HD.getServices().userSrv.setCoins(-gold, true);
                    }
                    break;
                    case SpecialType.TYPE2: {
                        let goods = 50045;

                        await new Promise<void>(async aresolve=>{
                            let url = "backpack/backpackPrefab";
                            let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
                            if(prefab){
                                let backpack = cc.instantiate(prefab);
                                backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.select,null,async (item:NormalBackpackI)=>{
                                    NormalGameManager._instance.onOutGoods(item.id,1);
                                    let bSelectCorrect = item.id == goods;
                                    if(bSelectCorrect){
                                        bFinish = true;
                                    } else {
                                        einfo = info.infoErr;
                                    }
                                    // resolve(!bSelectCorrect);
                                    
                                    aresolve();
                                });
                                this.node.addChild(backpack);
                            }
                        });
                    }
                    break;
                }
            }
            event.getCurrentTarget().destroy();
            this.nodeSpecialList.removeAllChildren();

            if (bFinish) {
                this.finishSpecialDispose();
            } else {
                this.startSpeicalDialogue(einfo);
            }
        } else {
            event.getCurrentTarget().destroy();
            this.nodeSpecialList.removeAllChildren();
            this.restoreRecord1();
        } 
    }

    async finishSpecialDispose() {

        this.showTalk('这《商贾秘术》是先祖留下的不传秘术，先交予公子保管');
        await PromiseUtil.sleep(2);
        this.showTalk('待我与家中取得联系，得到家中支持方能与公子成婚，还请公子等待些日子');

        this.nodeSpecialList.removeAllChildren();

        let nodeItem = cc.instantiate(this.nodeSpecialItem);
        nodeItem.active = true;

        let label = nodeItem.getChildByName('Label').getComponent(cc.Label);
        label.string = '好  的';
        nodeItem.parent = this.nodeSpecialItem.parent;
        let btnCom = nodeItem.getComponent(cc.Button);
        btnCom.clickEvents[0].customEventData = 'finish';
    }

    async sendSpecialGoods() {
        let addGoodsList = {};
        addGoodsList[50044] = 1;
        await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        utilsModel.onPushGoods(50044, 1);
    }

    restoreRecord1() {
        this.refreshSpeical1State();

        if (this.nodeSell.scale == 0) {
            this.nodeSell.scale = 1;
        }

        if (this.nodeMain.scale == 0) {
            this.nodeMain.scale = 1;
        }
        this.showTalk(this.recordTalk1);
    }

    onClickRole() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.bOpenRansom) {
            this.showSpecialTalk1();
            return;
        }
        let lv = Number(this.csvInfo.id);
        if (!lv || lv < 3) {
            this.touchCount = 0;
            return;
        }

        this.touchCount++;
        if (this.touchCount == 1) {
            this.showTalk('不要这样子，别人会误会的');
        }
        
        if (this.touchCount >= 5) {
            this.resetTouchCount();
            this.openRansomGoodsLayer();
        } else {
            this.scheduleOnce(this.resetTouchCount, c_reset_touch_time);
        }
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }
    // update (dt) {}
}
